import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";

import useApiErrorHandler from "../useApiErrorHandler";
import useLoading from "../useLoading";
import useAlerts from "../useAlerts";


import {
  setLoading,
  setProgress,
  setError,
  resetProgressState,
  setCompleted,
} from "../../store/slices/dte/testProgressSlice";
import TestProgressService from "../../services/dte/TestProgressService";

export const useTestProgress = () => {
  const dispatch: AppDispatch = useDispatch();
  const { handle } = useApiErrorHandler();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
  const { show: showAlert } = useAlerts();

  // ==============================
  // STATE
  // ==============================
  const { progress, completed, loading, error } = useSelector(
    (state: RootState) => state.testProgress
  );

  // ==============================
  // FETCH PROGRESS
  // ==============================
  const fetchProgress = async () => {
    try {
      dispatch(setLoading(true));
      showLoadingIndicator();

      const response = await TestProgressService.getProgress();
      const {
        statusCode,
        // type,
        // title,
        // message,
        data
      } = response;

      if (statusCode === 200) {
        dispatch(setProgress(data));
        // showAlert(type, title, message);
      }
    } catch (err) {
      dispatch(setError("No se pudo obtener el progreso."));
      handle(err);
    } finally {
      dispatch(setLoading(false));
      hideLoadingIndicator();
    }
  };

  const fetchCompleted = async () => {
    try {
      const response = await TestProgressService.getCompleted();
      console.log(response);
      const { statusCode, data } = response;

      if (statusCode === 200) {
        dispatch(setCompleted(data));
      }
    } catch (err) {
      handle(err);
    }
  };

  // ==============================
  // RESET STATE
  // ==============================
  const reset = () => dispatch(resetProgressState());

  return {
    // state
    progress,
    completed,
    loading,
    error,

    // actions
    fetchProgress,
    fetchCompleted,
    reset,
  };
};

export default useTestProgress;
